import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { ProcessoCadastro } from '../../../models/processo-cadastro.model';
import { ProcessoCadastroService } from '../../../services/processo-cadastro.service';

@Component({
  selector: 'app-processo-edit',
  templateUrl: './processo-edit.component.html',
  styleUrls: ['./processo-edit.component.scss']
})
export class ProcessoEditComponent extends BaseFormComponent<ProcessoCadastro> implements OnInit {

  actionLabel: string = "Novo";
  filters: any;
  modalQuestionRef?: BsModalRef;
  modalCloneRef?: BsModalRef;
  question: any;
  questionListTable: any[] = [];
  disabledBtn: boolean = true;

  disabledComoQuestion: boolean = false;
  isReadonly: boolean = false;
  
  clone_title: string;
  formData: any;

  @ViewChild('modalQuestion') modalQuestion: TemplateRef<any>;
  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProcessoCadastroService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private modalService: BsModalService,
    private router: Router,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.filters = this.activatedRoute.snapshot.data['filters'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(null, [Validators.required]),
      presentation: new FormControl(null),
      dt_start: new FormControl(null),
      dt_subscription: new FormControl(null),
      dt_conclusion: new FormControl(null),
      processagencytarget: new FormArray([new FormControl(null)]),
      adjunct: new FormArray([new FormControl(null)]),
      processprocessstat: new FormArray([new FormControl(null)]),
      questions: new FormControl(null),
    });
    
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.isReadonly = this.entity?.readonly

      if (this.entity?.processagencytarget?.length) {
        if (this.entity?.agency?.length) {
          this.filters.agencyList.push(...this.entity?.agency);
        }
        this.getFormArray('processagencytarget').clear();
        this.entity?.processagencytarget.forEach(item => {
          this.getFormArray('processagencytarget').push(new FormControl(item));
        })
      }

      if (this.entity?.adjunct?.length) {
        if (this.entity?.adjunctList?.length) {
          this.filters.personList.push(...this.entity?.adjunctList);
        }
        this.getFormArray('adjunct').clear();
        this.entity?.adjunct.forEach(item => {
          this.getFormArray('adjunct').push(new FormControl(item));
        })
      }
      if (this.entity?.processprocessstat?.length) {
        if (this.entity?.processStatList?.length) {
          this.filters.processprocessstatList.push(...this.entity?.processStatList);
        }
        this.getFormArray('processprocessstat').clear();
        this.entity?.processprocessstat.forEach(item => {
          this.getFormArray('processprocessstat').push(new FormControl(item));
        })
      }

      if (this.entity?.question) {
        this.questionListTable = [];
        this.entity?.question.forEach((list) => {
          this.filters?.questionList.forEach((question) => {
            if (list.question_id == question.id) {
              let obj = {
                id: list?.id,
                label: question?.label,
                question_id: list?.question_id,
                allow_null: String(list?.allow_null),
                nro_ord: list?.nro_ord,
                isQuestionUsed: list?.isQuestionUsed,
                isDisabled: list?.isDisabled,
              }
              this.questionListTable.push(obj);
            }
          })
        })
      }

      if (this.entity?.readonly) {

        this.disableReadOnlyFields()
        
        //função que recupera dados do formulário mesmo quando os campos foram desabilitados
        const getFormValuesWithDisabled = (form: FormGroup) => {
          const values = { ...form.getRawValue() };
          Object.keys(form.controls).forEach(key => {
            const control = form.get(key);
            if (control.disabled) {
              control.enable({ emitEvent: false });
              values[key] = control.value;
              control.disable({ emitEvent: false });
            }
          });
          return values;
        };

        // Captura os valores do formulário, incluindo os desabilitados
       this.formData = getFormValuesWithDisabled(this.form);
      }

      this.disabledBtn = (!this.entity?.can_save && this.entity?.readonly);
    }
  }

  addQuestions() {
    const validarQuestionRepetido = this.questionListTable.some((item) => {
      return (item?.question_id == this.question?.id);
    });
    if (validarQuestionRepetido) {
      this.msgError("Não posso repetir Questão disponível");
    } else {
      if (this.question) {
        let obj = {
          question_id: this.question?.id,
          label: this.question?.label,
          allow_null: "0",
          nro_ord: this.questionListTable?.length,
        }
        this.questionListTable.push(obj);
      }
    }
    this.closeQuestionModal();
    this.question = null;
  }

  removeQuestion(index: number) {
    this.questionListTable.splice(index, 1);
  }

  getFormArray(form: string): FormArray {
    return this.form.get(form) as FormArray;
  }

  addField(form: string) {
    this.getFormArray(form).push(new FormControl(null));
  }

  removeField(index: number, form: string) {
    this.getFormArray(form).removeAt(index);
  }

  disableReadOnlyFields(): void {
    this.form.get('title').disable();
    this.form.get('presentation').disable();
    this.form.get('dt_start').disable();
    this.form.get('dt_subscription').disable();
    this.form.get('dt_conclusion').disable();
    this.form.get('presentation').disable();
    this.form.get('processagencytarget').disable();
    this.form.get('adjunct').disable();
    this.form.get('processprocessstat').disable();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questionListTable, event.previousIndex, event.currentIndex);
    this.questionListTable.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'processos']);
  }

  getDataCreate(): ProcessoCadastro {
    let data: ProcessoCadastro;

    if(this.entity?.readonly){
      data = Object.assign({}, this.entity, this.formData);
    }else{
     data = Object.assign({}, data, this.form.value);
    }

    data.manager = { adjunct: data?.adjunct };
    data.questions = this.questionListTable;

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (data?.dt_start && !formatoDataRegex.test(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    } else if (!data?.dt_start) {
      data.dt_start = '';
    }
    if (data?.dt_conclusion && !formatoDataRegex.test(data.dt_conclusion)) {
      data.dt_conclusion = formatDate(data.dt_conclusion, 'DD/MM/YYYY');
    } else if (!data?.dt_conclusion) {
      data.dt_conclusion = '';
    }
    if (data?.dt_subscription && !formatoDataRegex.test(data.dt_subscription)) {
      data.dt_subscription = formatDate(data.dt_subscription, 'DD/MM/YYYY');
    } else if (!data?.dt_subscription) {
      data.dt_subscription = '';
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res) => {
            this.confirmation().subscribe(() => {
              this.navigation.replace(['/pre-projeto', 'processos', res.id])
            })
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
    else {
      this.markAsDirty();
    }
  }

  update(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id && this.entity?.can_save) {
        this.form.enable();
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.entityRefresh();
              EventSharedService.get('auditRefresh').emit();
              this.disableReadOnlyFields();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  entityRefresh() {
    this.addSub(
      this.myService.getById(this.entity?.id).subscribe({
        next: (res) => {
          this.entity = res;
          this.initForm();
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

  fieldMessageRequireds(form: string, field: string, index: number): boolean {
    return this.getFormArray(form).controls[index].get(field).invalid && this.getFormArray(form).controls[index].get(field).dirty;
  }

  fieldErrosFormArray(form: string, field: string, index: number) {
    return this.getFormArray(form).controls[index].get(field)?.errors;
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'processos']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }

  closeQuestionModal() {
    this.modalQuestionRef?.hide();
  }

  openQuestionModal() {
    this.modalQuestionRef = this.modalService.show(this.modalQuestion);
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.entity?.id && this.entity?.can_clone) {
      const obj = {
        clone_id: this.entity.id,
        clone_title: this.clone_title,
      }
      this.addSub(
        this.myService.clonar(obj).subscribe({
          next: (res) => {
            this.loaded();
            this.entity.id = res.id;
            this.confirmation('Clonado com sucesso!').subscribe(() => {
              this.router.navigate(['/pre-projeto', 'processos', res.id, 'cadastro']).then(() => {
                this.entityRefresh();
              });
            })
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }
}
